import { Routes } from '@angular/router';
import { EditClonesComponent } from './edit-clones/edit-clones.component';
import { ListeClonesComponent } from './liste-clones/liste-clones.component';

export const CLONES_ROUTES_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP']
};

export const CLONES_ROUTES: Routes = [
    { path: '', component: ListeClonesComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id', component: EditClonesComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new', component: EditClonesComponent, data: { roles: ['ORGANISME'] } }
];
